import React from "react";
import { Link } from "react-router-dom";
import styles from "./CustomButton.module.css";

type Variant = "outline" | "filled";
type Size = "small" | "medium" | "large";

export interface CustomButtonProps {
  text: string;
  to?: string;                 
  variant?: Variant;          
  size?: Size;                
  onClick?: () => void;
  className?: string;
  asChild?: boolean;            
  title?: string;
  disabled?: boolean;
  type?: "button" | "submit" | "reset"; 
}

const CustomButton: React.FC<CustomButtonProps> = ({
  text,
  to,
  variant = "outline",
  size = "medium",
  onClick,
  className = "",
  asChild = false,
  title,
  disabled = false,
  type = "button",            
}) => {
  const classes = [
    styles.buttonBase,
    styles[variant],
    styles[size],
    disabled ? styles.isDisabled : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const content = <span className={styles.label}>{text}</span>;

  if (to && !asChild) {
    return (
      <Link
        to={to}
        className={classes}
        onClick={disabled ? (e) => e.preventDefault() : onClick}
        aria-disabled={disabled || undefined}
        tabIndex={disabled ? -1 : 0}
        title={title}
      >
        {content}
      </Link>
    );
  }

  return (
    <button
      type={type}
      className={classes}
      onClick={onClick}
      disabled={disabled}
      title={title}
    >
      {content}
    </button>
  );
};

export default CustomButton;